export default __webpack_public_path__ + "static/media/O-028.dbccf9dc.png";